// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
function IconTriangleUp(Props) {
  var className = Props.className;
  var tmp = {
    height: "10",
    width: "20",
    viewBox: "0 0 20 10"
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return React.createElement("svg", tmp, React.createElement("path", {
    d: "M0 10 L10 0 L20 10",
    fill: "currentColor"
  }));
}
IconTriangleUp.displayName = "IconTriangleUp";
var make = React.memo(IconTriangleUp);
export { make };
/* make Not a pure module */